import React from 'react';
import { CombinedSettingsTypes } from '../../../../../domain/settings';
import {
    HalfYearFilter, MonthYearRangeFilter, QuarterFilter, SingleMonthYearFilter,
    StatsFilters as StatsFiltersType,
    TIME_PERIOD_OPTIONS,
    TimePeriod,
} from '../../../../../domain/statsFilters';
import { MonthRangePicker } from './MonthRangePicker';
import { SingleMonthPicker } from './SingleMonthPicker';
import { QuarterPicker } from './QuarterPicker';
import { HalfYearPicker } from './HalfYearPicker';
import { YearPicker } from './YearPicker';

type TimeFilterComponentProps = {
    timePeriod: TimePeriod;
    filtersState: StatsFiltersType;
    onChange: (newFilters: Partial<StatsFiltersType>) => void;
    settings: CombinedSettingsTypes;
}

export const TimeFilterComponent = ({ timePeriod, filtersState, onChange, settings }: TimeFilterComponentProps) => {
    if (timePeriod === 'single-month') {
        return (
            <div className="me-3">
                <h6>Wyszukaj po miesiacu i roku</h6>
                <SingleMonthPicker
                    singleMonthYear={filtersState.singleMonthYear || (TIME_PERIOD_OPTIONS['single-month'].defaultStats as SingleMonthYearFilter).singleMonthYear}
                    onChange={(singleMonthYear) => onChange({ singleMonthYear })}
                />
            </div>
        );
    }

    if (timePeriod === 'month-range') {
        return (
            <div className="me-3">
                <h6>Wyszukaj po zakresie miesiecy</h6>
                <MonthRangePicker
                    monthYearRange={filtersState.monthYearRange || (TIME_PERIOD_OPTIONS['month-range'].defaultStats as MonthYearRangeFilter).monthYearRange}
                    onChange={(monthYearRange) => onChange({ monthYearRange })}
                />
            </div>
        );
    }

    if (timePeriod === 'quarter') {
        return (
            <div className="me-3">
                <h6>Wyszukaj po kwartale</h6>
                <QuarterPicker
                    quarterFilters={filtersState.quarter || (TIME_PERIOD_OPTIONS['quarter'].defaultStats as QuarterFilter).quarter}
                    onChange={(quarter) => onChange({ quarter })}
                    startYear={settings.otherSettings.startYear}
                />
            </div>
        );
    }

    if (timePeriod === 'half-year') {
        return (
            <div className="me-3">
                <h6>Wyszukaj po półroczu</h6>
                <HalfYearPicker
                    halfYearFilters={filtersState.halfYear || (TIME_PERIOD_OPTIONS['half-year'].defaultStats as HalfYearFilter).halfYear}
                    onChange={(halfYear) => onChange({ halfYear })}
                    startYear={settings.otherSettings.startYear}
                />
            </div>
        );
    }

    if (timePeriod === 'year') {
        return (
            <div className="me-3">
                <h6>Wyszukaj po roku</h6>
                <YearPicker
                    yearFilter={filtersState.yearFilter || (TIME_PERIOD_OPTIONS['year'].defaultStats as any).yearFilter}
                    onChange={(yearFilter) => onChange({ yearFilter })}
                    startYear={settings.otherSettings.startYear}
                />
            </div>
        );
    }

    return null;
};
